import axios from 'axios';
import { settings } from '../../settings';
import { activatePolygon, assignTeamZips, clearPolygonOutcomes, createPolygon, deactivatePolygons, deletePolygons, getArea, getAreaBoundaries, getAreaDispositions, getAreaList, getAreas, getAreaTeamList, getAreaTeams, getAreaTeamStatistics, getPolygonPreview, getPolygonStatistics, getTeam, getTeamCells, getTeamDispositions, getTeamPins, getTeamPolygons, getTeamReps, getTeams, reassignRepsToPolygons, unassignRepsFromPolygons, unassignTeamZips, updatePolygonBoundaries, } from './endpoints';
const Api = {
    activatePolygon,
    assignTeamZips,
    clearPolygonOutcomes,
    createPolygon,
    deactivatePolygons,
    deletePolygons,
    getArea,
    getAreaBoundaries,
    getAreaDispositions,
    getAreaList,
    getAreas,
    getAreaTeamList,
    getAreaTeams,
    getAreaTeamStatistics,
    getPolygonPreview,
    getPolygonStatistics,
    getTeam,
    getTeamCells,
    getTeamDispositions,
    getTeamPins,
    getTeamPolygons,
    getTeamReps,
    getTeams,
    reassignRepsToPolygons,
    unassignRepsFromPolygons,
    unassignTeamZips,
    updatePolygonBoundaries,
};
const getAxiosRequestConfig = (method, url, params, payload) => {
    const config = {
        method,
        baseURL: settings.apiUrl,
        url: url,
        params: params,
        headers: {
            'Accept': 'application/vnd.api+json',
            'Authorization': `Bearer ${settings.JWT}`,
        },
    };
    if (['delete', 'patch', 'post', 'put'].includes(method)) {
        config['data'] = payload;
        config['headers']['Content-Type'] = 'application/vnd.api+json';
    }
    return config;
};
// TODO: Make this a generic function
const createNoPayloadApiMethod = (method) => ((url, params) => axios.request(getAxiosRequestConfig(method, url, params)));
// TODO: Make this a generic function
const createWithPayloadApiMethod = (method) => ((url, params, payload) => axios.request(getAxiosRequestConfig(method, url, params, payload)));
const Factory = {
    get: createNoPayloadApiMethod('get'),
    head: createNoPayloadApiMethod('head'),
    options: createNoPayloadApiMethod('options'),
    delete: createWithPayloadApiMethod('delete'),
    patch: createWithPayloadApiMethod('patch'),
    post: createWithPayloadApiMethod('post'),
    put: createWithPayloadApiMethod('put'),
};
export { Api, Factory, };
